module.exports = __webpack_public_path__ + "static/media/PBDQ_Style_Digital.8dd98825.png";